import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { kycPortalService } from '../../services/kycPortalService';
import KYCPortalShell from './KYCPortalShell';
import PasswordInput from '../ui/PasswordInput';

const KYCPortalLogin = () => {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSubmitting(true);
        try {
            await kycPortalService.login(email.trim(), password);
            history.push('/kyc-portal');
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <KYCPortalShell subtitle="Partner Sign In">
            <div className="kyc-portal-auth-wrap">
                <div className="kyc-portal-auth-card">
                    <h2>Sign in</h2>
                    <p className="kyc-portal-help">
                        Use the email address IMT invited you with and the password you set.
                    </p>
                    {error && <div className="kyc-portal-error">{error}</div>}
                    <form onSubmit={handleSubmit}>
                        <div className="kyc-portal-field">
                            <label>Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                autoFocus
                                autoComplete="email"
                            />
                        </div>
                        <div className="kyc-portal-field">
                            <label>Password</label>
                            <PasswordInput
                                value={password}
                                onChange={(event) => setPassword(event.target.value)}
                                autoComplete="current-password"
                            />
                        </div>
                        <button
                            type="submit"
                            className="kyc-portal-btn-primary"
                            disabled={submitting || !email || !password}
                            style={{ width: '100%', justifyContent: 'center' }}
                        >
                            {submitting ? 'Signing in…' : 'Sign In'}
                        </button>
                    </form>
                    <p className="kyc-portal-help" style={{ marginTop: '1rem', marginBottom: 0 }}>
                        Lost your access? Contact your IMT representative to resend the invitation.
                    </p>
                </div>
            </div>
        </KYCPortalShell>
    );
};

export default KYCPortalLogin;
